import React from 'react';
import logoVrio from '~/assets/light-logo.svg';
import { Container } from './styles';

const Helpe: React.FC = () => {
  return (
    <Container>
      <div className="content">
        <div className="header-help">
          <img src={logoVrio} alt="logo" />

          <div className="welcome">
            <h2>Bem-vindo</h2>
            <h1>Portal LGPD</h1>
          </div>
        </div>

        <h1>
          Não foi possível exibir o Portal LGPD através desta URL digitada. Por
          favor, acesse o site institucional da empresa com a qual você possui
          relacionamento e acione o link que o direciona à página desejada.
        </h1>
      </div>
    </Container>
  );
};

export default Helpe;
